import { toast } from "react-toastify";

export const removeItemToWatchlist = (e, id, setIsCoinAdded) => {
  e.preventDefault();
  e.stopPropagation(); // Added this
  
  let watchlist = JSON.parse(localStorage.getItem("watchlist")) || []; // Added fallback
  const coinName = id.substring(0, 1).toUpperCase() + id.substring(1);

  if (!watchlist.includes(id)) {
    toast.info(`ℹ️ ${coinName} is not in your watchlist!`, {
      position: "bottom-right",
      autoClose: 3000,
    });
    return false;
  }

  // Remove confirmation for better UX (optional - you can keep it if you prefer)
  const newList = watchlist.filter((coin) => coin !== id);
  localStorage.setItem("watchlist", JSON.stringify(newList));
  
  if (setIsCoinAdded) {
    setIsCoinAdded(false);
  }
  
  toast.error(`🗑️ ${coinName} removed from watchlist!`, {
    position: "bottom-right",
    autoClose: 3000,
  });
  
  return true;
};